module.exports = __webpack_public_path__ + "img/bth_bed2_right_nor.7dce8d78.png";